import { useEffect, useState } from "react";

import DstButton from "../../../../components/DstButton/DstButton";
import MultiSelectDropdown from "../../../../components/MultiSelectDropdown/MultiSelectDropdown";
import Popup from "../../../../components/Popup/Popup";
import translate from "../../../../services/Translate";
import { Flag } from "../../Course.d";
import { CourseStageFlagsPopupProperties } from "./CourseStageFlagsPopup.d";
import { fetchFlags, updateCursusStageFlags } from "./CourseStageFlagsPopup.function";

export const CourseStageFlagsPopup = ({
  language,
  openPopup,
  setOpenPopup,
  cursusStage,
  onFlagsUpdated,
}: CourseStageFlagsPopupProperties) => {
  const [selectedFlagIds, setSelectedFlagIds] = useState<number[]>([]);
  const [flags, setFlags] = useState<Flag[]>([]);
  const [isFlagsLoading, setIsFlagsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (openPopup) {
      setSelectedFlagIds(cursusStage.flags?.map((flag) => flag.id) || []);
      fetchFlags(language, setFlags, setIsFlagsLoading);
    }
  }, [openPopup, cursusStage, language]);

  return (
    <Popup
      show={openPopup}
      onClose={() => setOpenPopup(false)}
      modalTitle={translate(language, "PAGES.COURSE.MODALS.EDIT_FLAGS.TITLE")}
    >
      <div className="d-flex flex-column">
        <div className="flex-grow-1">
          <MultiSelectDropdown
            label={
              selectedFlagIds.length > 0
                ? `${translate(language, "PAGES.COURSE.MODALS.EDIT_FLAGS.FLAGS_SELECTED")} ${selectedFlagIds.length}`
                : translate(language, "PAGES.COURSE.MODALS.EDIT_FLAGS.SELECT_FLAGS")
            }
            language={language}
            items={flags}
            mock={isFlagsLoading}
            toggleClass="border"
            badgeItemProperty="name"
            displayItem={(item) => item.name}
            defaultSelectedItems={cursusStage.flags || []}
            onConfirm={(selectedItems) => setSelectedFlagIds(selectedItems.map((item) => item.id))}
          />
        </div>
        <div className="d-flex justify-content-end mt-4">
          <DstButton
            btnWidth="100px"
            variant="primary"
            value={translate(language, "PAGES.COURSE.MODALS.EDIT_FLAGS.CONFIRM_BUTTON")}
            clickFunction={() => {
              updateCursusStageFlags(language, cursusStage.id, selectedFlagIds, setIsSaving, () => {
                onFlagsUpdated(flags.filter((flag) => selectedFlagIds.includes(flag.id)));
                setOpenPopup(false);
              });
            }}
            btnClass="me-2"
            disabled={isSaving}
            loading={isSaving}
          />
        </div>
      </div>
    </Popup>
  );
};

export default CourseStageFlagsPopup;
